<template>
    <ai-grid-edit-wrapper
        ref='componentRef'
        :meta='meta'
        heigth="100%"
        :to-remove-toolbar-items-names='removeGridToolbarBtns'
        :action="action"
        @user-settings-changed="onUserSettingsChanged"
        @grid-focus-changed="onGridFocusChanged"
        @user-data-changed="onUserDataChanged"
        @refresh="onRefreshHandler"
        @dataLoaded="onDataLoadedHandler"
        @gridEditWrapperMounted="onGridEditWrapperMounted"
        @changesSavedSuccessfully="onChangesSavedSuccessfully"
        @changesRemoved="onChangesRemoved"
        @userDataChangedLoaded="onUserDataChangedLoaded"
    />
</template>
<script>
export default {
    name: 'dk-zz-otkl-view',
};
</script>
<script setup>
import { ref } from 'vue';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';
import AiGridEditWrapper from '@/components/wrappers/ai-grid-edit-wrapper.vue';

const componentRef = ref(null);

const emit = defineEmits([]);
const onChangesRemoved = () => {
    emit('changesRemoved');
};

const onDataLoadedHandler = () => {
    emit('dataLoaded');
};

const onChangesSavedSuccessfully = () => {
    emit('changesSavedSuccessfully');
};

const onUserDataChangedLoaded = userData => {
    emit('userDataChangedLoaded', userData);
};

const onGridEditWrapperMounted = async () => {
    setActiveViewInfo({
        refresh: componentRef.value.ref.setDataSource,
        userData: () => {},
        userSettings: () => {},
    });

    await setViewData();
    emit('gridEditWrapperMounted');
};
const onRefreshHandler = () => {
    emit('refresh');
};

const onUserDataChanged = args => {
    emit('userDataChanged', args);
};
const onGridFocusChanged = (row, viewId, rowIndex, component) => {
    emit('gridFocusChanged', row, viewId, rowIndex, component);
};
const onUserSettingsChanged = (settings, autoSaveMode) => {
    emit('userSettingsChanged', settings, autoSaveMode);
};
defineExpose({
    onDataLoadedHandler,
    onRefreshHandler,
    onUserDataChanged,
    onGridFocusChanged,
    onUserSettingsChanged,
    onGridEditWrapperMounted,
    onChangesSavedSuccessfully,
    onChangesRemoved,
    onUserDataChangedLoaded,
    componentRef,
});

const removeGridToolbarBtns = ['choice', 'edit', 'show-column-chooser', 'searchPanel', 'copy', 'add', 'delete'];

const meta = {
    "keyExpr": "kod_zz_otkl",
    selectButtonMode: 'single',
    selectionMode: 'single',
    "columns": [
        {
            "name": "kod_zz_otkl",
            "caption": "Код",
            "dataField": "kod_zz_otkl",
            "allowEditing": false,
            "width": 150,
            "index": 1,
            "visible": false
        },
        {
            "name": "koef_dog",
            "caption": "Коэффициенты отклонения заявленных объемов теплопотребления от договорного теплопотребления",
            "dataField": "koef_dog",
            "allowEditing": true,
            "width": '50%',
            'dataType': 'number',
            "index": 2,
            "visible": true
        },
        {
            "name": "koef_fact",
            "caption": "Коэффициенты отклонения заявленных объемов теплопотребления от фактического теплопотребления",
            "dataField": "koef_fact",
            "allowEditing": true,
            "width": '50%',
            'dataType': 'number',
            "index": 3,
            "visible": true
        },
    ],
    "api": {
        "select": "tep-nsi./tep-nsi/dk-zz-otkl/select/get",
        "save": "tep-nsi./tep-nsi/dk-zz-otkl/save/set"
    },
    "viewId": "view-dk-zz-otkl",
    isFilterPanelVisible: false,
}
</script>


